'use client'

// Next.js
import Link from 'next/link'

// Icons
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline'

// Utils
import { Join } from '../../lib/utils'

export interface SectionFooterLinkProps {
  href: string
  children: React.ReactNode
  /** Optional. Default: true when href starts with http(s) */
  external?: boolean
  className?: string
}

const linkClass =
  'inline-flex items-center gap-1.5 font-mono text-[10px] text-slate-500 transition-colors hover:text-slate-700 dark:hover:text-slate-300'

/**
 * A single link placed at the bottom of a section (e.g. "See demos", "Read more").
 * Internal paths use Next.js Link; external URLs use <a target="_blank" rel="noopener noreferrer"> and show an external icon.
 */
export function SectionFooterLink({
  href,
  children,
  external = href.startsWith('http'),
  className,
}: SectionFooterLinkProps) {
  if (external) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={Join(linkClass, className)}
      >
        {children}
        <ArrowTopRightOnSquareIcon className="size-2.5" aria-hidden />
      </a>
    )
  }
  return (
    <Link href={href} className={Join(linkClass, className)}>
      {children}
    </Link>
  )
}
